<template>
  <v-form v-model="valid" ref="dialigform">
    <slotted-dialog :externalCloseTrigger="closeTrigger" :externaltrigger="openTrigger" @close="_cancel" :title="title">

      <template v-slot:content>
        <MachineCustomerEditContent :key="'ggg-' + openTrigger" :editItem="editObject" :editMode="true"
          :handleFocus="() => { }" class="mt-3">
        </MachineCustomerEditContent>
        <h4 v-text="$t('servicesystem.common_objects.machine.product')" class="px-3" />
        <MachineProductEditContent :key="'lll-' + openTrigger" :editItem="editObject" :editMode="true"
          :handleFocus="() => { }">
        </MachineProductEditContent>
        <h4 v-text="$t('servicesystem.common_objects.commonterms.details')" class="px-3" />
        <MachineDetailsEditContent :key="'jjj-' + openTrigger" :editItem="editObject" :editMode="true"
          :handleFocus="() => { }">
        </MachineDetailsEditContent>
      </template>

      <template v-slot:buttons>
        <v-btn @click="_cancel" color="primary" outlined v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn v-text="$t('servicesystem.common_objects.commonterms.create')" :color="valid ? 'primary' : 'disabled'"
          @mouseenter="$refs.dialigform.validate()" @click="valid ? addMachine() : null">
        </v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import MachineCustomerEditContent from "@/views/admin/machines/MachineCustomerEditContent.vue";
import MachineDetailsEditContent from "@/views/admin/machines/MachineDetailsEditContent.vue";
import MachineProductEditContent from "@/views/admin/machines/MachineProductEditContent.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "CreateMachineDialog",
  components: {
    SlottedDialog,
    MachineDetailsEditContent,
    MachineProductEditContent,
    MachineCustomerEditContent,
  },
  mixins: [clientAPI],

  data: () => ({
    valid: true,

    editObject: {},

    customerList: [],

    customerReadOnly: false,
    title: "",
    openTrigger: 0,
    closeTrigger: 0,

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    setItem() {
      this.editObject = {
        CustomerId: "",
        Name: "",
        SerialNumber: "",
        MachineModel: null,
        Supplier: null,
        MachineType: null,
        AssetType: null,
        FirmId: this.userInfo.FirmId,
      };
    },

    // used by main component reference
    show(opts = {}) {
      this.setItem();
      this.title = opts.title;
      this.customerList = opts.customerList;
      if (opts.customerId) {
        this.editObject.CustomerId = opts.customerId;
      } else {
        //download all customers here
        this.customerReadOnly = false;
      }
      // Once we set our config, we tell the popup modal to open
      this.openTrigger++;
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    addMachine() {
      const body = Object.assign({}, this.editObject);
      this.createMachine(body)
        .then((response) => {
          this._confirm(response);
        })
        .catch((/*response*/) => {

        });
    },

    _confirm(val) {
      this.closeTrigger++;
      this.resolvePromise(val);
    },

    _cancel() {
      this.closeTrigger++;
      this.resolvePromise(false);
    },
  },

  computed: {},

  watch: {},
};
</script>